export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgIi9hc3NldHMvbG9nby5kMGM5ZmJlMy5iMjViOGFhZi0yYjBiLTQ0YTQtYWY3OC1kZWMzOWNlOTBjOWYucG5nIjs="